import {Breadcrumbs, Link, Stack, Typography} from "@mui/material";
import {Link as RouterLink, Navigate, useNavigate} from "react-router-dom";
import * as React from "react";
import {appSession} from "../../Broadtask";
import DIOSManagerPane from "../../components/dios/DIOSManagerPane";

const DIOSManager = () =>
{
    const navigate = useNavigate();

    return <Stack spacing={1} >
        <Stack direction="row"
               sx={{ backgroundColor: '#182229'}}
               alignItems="center" justifyContent="space-between" padding={1}>
            <Breadcrumbs>
                <Link component={RouterLink} to={"/"} underline={"hover"}>Home</Link>
                <Typography>Data Sources</Typography>
            </Breadcrumbs>
        </Stack>

        {
            appSession.activeSession() === false ?
            <Navigate to="/login"/> :
            <Stack direction="column"
                   justifyContent="flex-start" alignItems="stretch"
                   spacing={2} padding={1}>

                <DIOSManagerPane />

            </Stack>
        }

    </Stack>
};

export default DIOSManager;
